const accessoryEpicFilterOptions = {
  epicCategories: {
    displayName: "Categories",
    values: [
      {
        displayName: "Handbags",
        id: "handbags",
      },
      {
        displayName: "Jewelry",
        id: "jewelry",
      },
      {
        displayName: "Sunglasses",
        id: "sunglasses",
      },
    ],
  },
  colors: {
    displayName: "Color",
    values: [
      {
        displayName: "Black",
        id: "black",
      },
      {
        displayName: "Grey",
        id: "grey",
      },
      {
        displayName: "White",
        id: "white",
      },
      {
        displayName: "Cream",
        id: "offwhite",
      },
      {
        displayName: "Brown",
        id: "brown",
      },
      {
        displayName: "Red",
        id: "red",
      },
      {
        displayName: "Orange",
        id: "orange",
      },
      {
        displayName: "Yellow",
        id: "yellow",
      },
      {
        displayName: "Green",
        id: "green",
      },
      {
        displayName: "Blue",
        id: "blue",
      },
      {
        displayName: "Purple",
        id: "purple",
      },
      {
        displayName: "Pink",
        id: "pink",
      },
      {
        displayName: "Multicolored",
        id: "multicolored",
      },
      {
        displayName: "Silver",
        id: "silver",
      },
      {
        displayName: "Rose Gold",
        id: "rosegold",
      },
      {
        displayName: "Gold",
        id: "gold",
      },
      {
        displayName: "Clear",
        id: "clear",
      },
    ],
  },
  epicEmbellishments: "omit",
  epicFormality: {
    displayName: "Dressiness",
    values: [
      {
        displayName: "Everyday Casual",
        id: "1",
      },
      {
        displayName: "Daytime",
        id: "2",
      },
      {
        displayName: "Night Out",
        id: "3",
      },
      {
        displayName: "Evening",
        id: "4",
      },
    ],
  },
  epicMaternity: "omit",
  epicPrint: "omit",
  epicUseCaseEvents: "omit",
  epicSeasonality: "omit",
  epicSleeve: "omit",
  epicLength: "omit",
  epicNeckline: "omit",
};

export default accessoryEpicFilterOptions;
export const {
  epicCategories,
  epicMaternity,
  epicUseCaseEvents,
  colors,
  epicEmbellishments,
  epicFormality,
  epicPrint,
  epicSleeve,
  epicLength,
  epicNeckline,
} = accessoryEpicFilterOptions;
